import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paper: { padding: theme.spacing(2), marginBottom: theme.spacing(2) },
  // Title and period selector on one line, wrapping on narrow viewports rather than
  // squeezing the selector — a truncated period label is worse than a second row, because
  // the period is what tells the operator what the numbers below it mean.
  header: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  // Wide enough for the longest preset ("Last 12 months") in both locales without the
  // select clipping its own value.
  period: { minWidth: 180 },
  // Wraps rather than scrolls: three stats fit a desktop row and stack on a phone, and a
  // horizontally scrolling summary hides the figure the operator came for.
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(4)
  },
  // minWidth 0 so a long formatted figure can shrink instead of forcing the row wider —
  // the same min-content floor that misaligned the promotions list, one layout down.
  stat: { display: 'flex', flexDirection: 'column', minWidth: 0 }
}))

export default useStyles
